export default "__VITE_PUBLIC_ASSET__66c95d2a__"